export default "__VITE_ASSET__Ix5ijMFi__"